import { render, staticRenderFns } from "./GuestHealthCheckForm.vue?vue&type=template&id=50461ff2&"
import script from "./GuestHealthCheckForm.vue?vue&type=script&lang=ts&"
export * from "./GuestHealthCheckForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports